<template lang="html">
  <section class="dashboard">
    <store-selector />
    <div class="row">
      <div class="col-xl-3 col-sm-6 grid-margin stretch-card">
        <div class="card card-statistics card-1">
          <div class="card-body">
            <div class="d-flex justify-content-between flex-wrap">
              <div>
                <i class="mdi mdi-cube text-danger icon-lg"></i>
              </div>
              <div>
                <p class="card-text text-right">Today's Orders</p>
                <div class="fluid-container">
                  <h3 class="card-title font-weight-bold text-right mb-0">{{ todaysOrderCount }}</h3>
                </div>
              </div>
            </div>
            <p class="text-muted mt-3">
              <i class="mdi mdi-alert-octagon mr-1" aria-hidden="true"></i> Order Count
            </p>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-sm-6 grid-margin stretch-card">
        <div class="card card-statistics card-1">
          <div class="card-body">
            <div class="d-flex justify-content-between flex-wrap">
              <div>
                <i class="mdi mdi-cube text-info icon-lg"></i>
              </div>
              <div>
                <p class="card-text text-right">Last 7 Orders</p>
                <div class="fluid-container">
                  <h3 class="card-title font-weight-bold text-right mb-0">{{ last7DaysOrders }}</h3>
                </div>
              </div>
            </div>
            <p class="text-muted mt-3">
              <i class="mdi mdi-alert-octagon mr-1" aria-hidden="true"></i> Order Count
            </p>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-sm-6 grid-margin stretch-card">
        <div class="card card-statistics card-1">
          <div class="card-body">
            <div class="d-flex justify-content-between flex-wrap">
              <div>
                <i class="mdi mdi-cube text-warning icon-lg"></i>
              </div>
              <div>
                <p class="card-text text-right">Last 30 Orders</p>
                <div class="fluid-container">
                  <h3 class="card-title font-weight-bold text-right mb-0">{{ last30DaysOrders }}</h3>
                </div>
              </div>
            </div>
            <p class="text-muted mt-3">
              <i class="mdi mdi-alert-octagon mr-1" aria-hidden="true"></i> Order Count
            </p>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-sm-6 grid-margin stretch-card">
        <div class="card card-statistics card-1">
          <div class="card-body">
            <div class="d-flex justify-content-between flex-wrap">
              <div>
                <i class="mdi mdi-cube text-success icon-lg"></i>
              </div>
              <div>
                <p class="card-text text-right">Last 90 Orders</p>
                <div class="fluid-container">
                  <h3 class="card-title font-weight-bold text-right mb-0">{{ last90DaysOrders }}</h3>
                </div>
              </div>
            </div>
            <p class="text-muted mt-3">
              <i class="mdi mdi-alert-octagon mr-1" aria-hidden="true"></i> Order Count
            </p>
          </div>
        </div>
      </div>

    </div>
    <draft-response-stats />
    <design-ratings />
    <order-item-status-stats />
    <drafts-response-statistics />
    
    <kpi-base />
    <div class="row">
      <div class="col-12 grid-margin">
        <div class="card card-1">
          <div class="card-body">
            <h5 class="card-title mb-4">Today's Orders</h5>
            <div class="table-responsive">
              <table class="table center-aligned-table" v-if="orders.length > 0">
                <thead>
                  <tr>
                    <th class="border-bottom-0">#</th>
                    <th class="border-bottom-0">Order No</th>
                    <th class="border-bottom-0">Product Name</th>
                    <th class="border-bottom-0">Purchased On</th>
        
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index1) in orders" :key="order.id">
                    <td>{{ index1 + 1 }}</td>
                    <td><div class="order_no">
                      <label class="badge badge-teal">{{ order.order_no }}</label>
                    </div></td>
                    <td>
                      <div v-for="(item, index) in order.ShopifyOrderItems" :key="item.id">
                        {{ index + 1 }}. {{ item.name }}
                      </div>
                    </td>
                    <td><div class="date-field">
                      {{ moment(order.created_in_shopify).utcOffset("+01:00").format('DD-MM-YYYY, h:mm a') }} 
                      
                      {{ order.created_in_shopify }}
                    </div></td>
                   
                  </tr>
                </tbody>
              </table>
               <b-alert show v-else variant="success">No order found for today</b-alert>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </section>
</template>

<script lang="js">
import DashboardService from '../../services/dashboard.service';
const KpiBase = () => import(/* webpackChunkName: "kpi.base-structure" */ '../../components/dashboard-widgets/kpi/kpi-base');
const StoreSelector = () => import(/* webpackChunkName: "store.selector" */ '../../components/dashboard-widgets/store-selector')
const DraftsResponseStatistics = () => import(/* webpackChunkName: "dashboard.draft-response-statistics" */ "../../components/dashboard-widgets/status-and-stats/drafts-response-statistics")
const OrderItemStatusStats = () => import(/* webpackChunkName: "dashboard.order-item-status-stats" */ "../../components/dashboard-widgets/order-item-status-stats/order-item-status-stats")
const DesignRatings = () => import(/* webpackChunkName: "dashboard.design-ratings" */ "../../components/dashboard-widgets/design-ratings/design-ratings")
const DraftResponseStats = () => import(/* webpackChunkName: "dashboard.draft-response-stats" */ "../../components/dashboard-widgets/draft-response-stats/draft-response-stats")
export default {
  data(){
    return {
       todaysOrderCount: 0,
       last7DaysOrders: 0,
       last30DaysOrders: 0,
       last90DaysOrders: 0,
       orders: [],
       selected: 0
    }
  },
  name: 'dashboard-root',
  mounted(){
    this.fetchStatistics();
  },
  methods: {
    async fetchStatistics(){
      try{
        const allStats = await DashboardService.fetchStatistics(this.selected);
        this.todaysOrderCount = allStats.data.todaysOrders.rows.length;
        this.last7DaysOrders = allStats.data.last7DaysOrders;
        this.last30DaysOrders = allStats.data.last30DaysOrders;
        this.last90DaysOrders = allStats.data.last90DaysOrders;
        this.orders = allStats.data.todaysOrders.rows
      }catch(errors){
        console.log(errors)
      }
    }
  },
  components: { KpiBase, 
                  StoreSelector, 
                  DraftsResponseStatistics, 
                  OrderItemStatusStats, 
                  DesignRatings, 
                  DraftResponseStats 
                },
  computed:{
       storeInState(){
         return this.$store.state.ecommerceStore.store
       }
     },
     watch: {
       storeInState(newValue, oldValue){
          console.log('New value', newValue);
           this.selected = newValue.id;
           this.fetchStatistics()
       }
     }
}
</script>

<style scoped lang="scss">
  .date-field{
    width: 200px;
  }
  .order_no{
    width: 120px;
  }
</style>
